// Stars animation
const starsContainer = document.getElementById('stars');
const starCount = 2000;
for(let i = 0; i < starCount; i++){
    const star = document.createElement('div');
    star.className = 'star';
    star.style.left = `${Math.random() * 100}%`;
    star.style.top = `${Math.random() * 100}%`;
    star.style.transform = `translateZ(${Math.random() * 500 - 250}px)`;
    star.style.setProperty('--duration', `${Math.random() * 3 + 1}s`);
    starsContainer.appendChild(star);
}
// Shooting stars animation
function createShootingStar() {
    const shootingStar = document.createElement('div');
    shootingStar.className = 'shooting-star';
    // Random starting position across the entire width
    const startX = Math.random() * (window.innerWidth + 500) - 250; // Include off-screen area
    const startY = -100; // Start above the viewport
    shootingStar.style.left = `${startX}px`;
    shootingStar.style.top = `${startY}px`;
    // Random rotation (between -15 and -45 degrees)
    const rotation = -(Math.random() * 30 + 15);
    shootingStar.style.setProperty('--rotation', `${rotation}deg`);
    // Random duration (between 1 and 2.5 seconds)
    const duration = Math.random() * 1.5 + 1;
    shootingStar.style.animationDuration = `${duration}s`;
    // Random size (between 100px and 200px)
    const size = Math.random() * 100 + 100;
    shootingStar.style.width = `${size}px`;
    // Random brightness
    const brightness = Math.random() * 0.5 + 0.5;
    shootingStar.style.opacity = brightness;
    starsContainer.appendChild(shootingStar);
    // Remove the shooting star after animation
    setTimeout(()=>{
        shootingStar.remove();
    }, duration * 1000);
}
// Create shooting stars at random intervals
function startShootingStars() {
    setInterval(()=>{
        // Adjust probability based on viewport size
        const probability = Math.min(window.innerWidth / 3000, 0.3);
        if (Math.random() < probability) createShootingStar();
    }, 1000); // Check every second
}
// Start the shooting stars animation
startShootingStars();
// Mouse movement effect
document.addEventListener('mousemove', (e)=>{
    const mouseX = e.clientX / window.innerWidth - 0.5;
    const mouseY = e.clientY / window.innerHeight - 0.5;
    starsContainer.style.transform = `
        rotateY(${mouseX * 20}deg)
        rotateX(${-mouseY * 20}deg)
        translateZ(-100px)
    `;
});
// Language handling
if (document.getElementById('mantra')) {
    const mantraElement = document.querySelector('#mantra');
    const mantras = {
        'hi': "\u0950 \u0928\u092E\u0903 \u0936\u093F\u0935\u093E\u092F",
        'en': 'Aum Namah Shivaya',
        'ta': "\u0B93\u0BAE\u0BCD \u0BA8\u0BAE\u0B83 \u0B9A\u0BBF\u0BB5\u0BBE\u0BAF",
        'te': "\u0C13\u0C02 \u0C28\u0C2E\u0C03 \u0C36\u0C3F\u0C35\u0C3E\u0C2F",
        'bn': "\u0993\u0981 \u09A8\u09AE\u0983 \u09B6\u09BF\u09AC\u09BE\u09AF\u09BC",
        'default': "\u0950 \u0928\u092E\u0903 \u0936\u093F\u0935\u093E\u092F"
    };
    const langNames = {
        'en': "\uD83C\uDDEC\uD83C\uDDE7 EN",
        'hi': "\uD83C\uDDEE\uD83C\uDDF3 \u0939\u093F\u0902\u0926\u0940",
        'ta': "\uD83C\uDDEE\uD83C\uDDF3 \u0BA4\u0BAE\u0BBF\u0BB4\u0BCD",
        'te': "\uD83C\uDDEE\uD83C\uDDF3 \u0C24\u0C46\u0C32\u0C41\u0C17\u0C41",
        'bn': "\uD83C\uDDE7\uD83C\uDDE9 \u09AC\u09BE\u0982\u09B2\u09BE"
    };
    function updateLanguageDisplay(lang) {
        const displayText = langNames[lang] || langNames['en'];
        currentLang.textContent = displayText;
    }
    // Language selection handlers
    document.querySelectorAll('.language-option').forEach((option)=>{
        option.addEventListener('click', ()=>{
            const lang = option.dataset.lang;
            mantraElement.textContent = mantras[lang] || mantras['default'];
            updateLanguageDisplay(lang);
            langDropdown.classList.remove('show');
            localStorage.setItem('selectedLang', lang);
        });
    });
    // Set initial language
    const savedLang = localStorage.getItem('selectedLang') || navigator.language.split('-')[0];
    mantraElement.textContent = mantras[savedLang] || mantras['default'];
    updateLanguageDisplay(savedLang);
    // Dropdown toggles
    const langBtn = document.getElementById('langBtn');
    const langDropdown = document.getElementById('langDropdown');
    langBtn.addEventListener('click', ()=>langDropdown.classList.toggle('show'));
    // Close dropdowns when clicking outside
    document.addEventListener('click', (e)=>{
        if (!langBtn.contains(e.target)) langDropdown.classList.remove('show');
    });
    // Mantra scroll effect
    window.addEventListener('scroll', function() {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const maxScale = 1.5;
        const minScale = 1.1;
        const scrollRange = windowHeight / 2;
        let scale = minScale + (1 - scrollPosition / scrollRange) * (maxScale - minScale);
        scale = Math.max(minScale, Math.min(maxScale, scale));
        if (scrollPosition <= scrollRange) mantra.style.transform = `scale(${scale})`;
    });
}
// Quote rotation (if on index page)
if (document.getElementById('quoteText')) {
    const shivaQuotes = [
        {
            text: "In the silence of meditation, one finds the eternal truth.",
            author: "Ancient Shiva Teaching"
        },
        {
            text: "When you learn to see the divine in everything, you become truly wise.",
            author: "Shiva Purana"
        },
        {
            text: "The universe is not outside of you. Look inside yourself; everything that you want, you already are.",
            author: "Ancient Shiva Teaching"
        },
        {
            text: "Your true nature is pure consciousness. Everything else is just a temporary appearance.",
            author: "Shiva Wisdom"
        },
        {
            text: "The mind is the cause of bondage and liberation. Master it, and find freedom.",
            author: "Ancient Yogic Teaching"
        },
        {
            text: "Like the moon reflects in countless waters, the Divine reflects in countless beings.",
            author: "Shiva Sutra"
        },
        {
            text: "In perfect balance between meditation and action lies the secret of life.",
            author: "Ancient Shiva Teaching"
        }
    ];
    function updateQuote() {
        const quoteText = document.getElementById('quoteText');
        const quoteAuthor = document.getElementById('quoteAuthor');
        const randomQuote = shivaQuotes[Math.floor(Math.random() * shivaQuotes.length)];
        quoteText.style.opacity = 0;
        quoteAuthor.style.opacity = 0;
        setTimeout(()=>{
            quoteText.textContent = randomQuote.text;
            quoteAuthor.textContent = `- ${randomQuote.author}`;
            quoteText.style.opacity = 1;
            quoteAuthor.style.opacity = 1;
        }, 500);
    }
    updateQuote();
    setInterval(updateQuote, 10000);
}
// Chat functionality
if (document.getElementById('chatInput')) {
    const chatMessages = document.getElementById('chatMessages');
    const chatInput = document.getElementById('chatInput');
    const sendButton = document.getElementById('sendMessage');
    const addMessage = (text, isUser = false)=>{
        const message = document.createElement('div');
        message.className = `message ${isUser ? 'user' : 'bot'}`;
        message.innerHTML = `
            <div class="message-content">
                <i class="fas ${isUser ? 'fa-user' : 'fa-om'} message-icon"></i>
                <div class="message-text">${text}</div>
            </div>
        `;
        chatMessages.appendChild(message);
        chatMessages.scrollTop = chatMessages.scrollHeight;
    };
    const handleUserMessage = async (text)=>{
        // Add user message
        addMessage(text, true);
        try {
            // Create and show the bot message container
            const botMessage = document.createElement('div');
            botMessage.className = 'message bot';
            botMessage.innerHTML = `
                <div class="message-content">
                    <i class="fas fa-om message-icon"></i>
                    <div class="message-text"></div>
                </div>
            `;
            chatMessages.appendChild(botMessage);
            const botResponseText = botMessage.querySelector('.message-text');
            botResponseText.textContent = ''; // Start empty
            chatMessages.scrollTop = chatMessages.scrollHeight;
            // Make streaming API call to Ollama
            const response = await fetch('http://103.151.184.145:11434/api/generate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    model: "llama2:7b",
                    prompt: `You are Nandi, the sacred vehicle and devoted companion of Lord Shiva. 
                            Respond to this question with spiritual wisdom, keeping responses concise and meaningful: ${text}`,
                    stream: true
                })
            });
            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let fullResponse = '';
            while(true){
                const { value, done } = await reader.read();
                if (done) break;
                // Decode the received chunk
                const chunk = decoder.decode(value);
                const lines = chunk.split('\n').filter((line)=>line.trim());
                // Process each line
                for (const line of lines)try {
                    const data = JSON.parse(line);
                    if (data.response) {
                        fullResponse += data.response;
                        botResponseText.textContent = fullResponse;
                        chatMessages.scrollTop = chatMessages.scrollHeight;
                    }
                } catch (e) {
                    console.error('Error parsing JSON:', e);
                }
            }
        } catch (error) {
            console.error('Error:', error);
            // Add error message
            addMessage("Forgive me, but I am unable to respond at this moment. Please try again later.");
        }
    };
    const sendMessage = ()=>{
        const text = chatInput.value.trim();
        if (text) {
            handleUserMessage(text);
            chatInput.value = '';
        }
    };
    sendButton.addEventListener('click', sendMessage);
    chatInput.addEventListener('keypress', (e)=>{
        if (e.key === 'Enter') sendMessage();
    });
}
// Add scroll listener for mantra scaling
window.addEventListener('scroll', ()=>{
    const mantra1 = document.querySelector('[data-scroll-scale]');
    if (!mantra1) return;
    const scrollPercent = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
    const scale = 1 + scrollPercent * 1; // Scale from 1x to 2x
    mantra1.style.transform = `scale(${scale})`;
});

//# sourceMappingURL=index.14dbeb1a.js.map
